import { ErrorPageTemplate } from '@/components/Templates/ErrorPageTemplate/ErrorPageTemplate';
import useTranslation from '@/hooks/useTranslation';
import { ErrorPage } from './ErrorPage';

export const ForbiddenPage = ({ ...rest }) => {
    const { t } = useTranslation();
    return <ErrorPage title={t('Feedback.sorryHeading')} message={t('Feedback.access_denied')} {...rest} />;
};

export const ForbiddenPageStandalone = () => (
    <ErrorPageTemplate title="No Access">
        <ForbiddenPage />
    </ErrorPageTemplate>
);
